<template>
  <div>
<!--    <el-dialog title="审批详情" :visible.sync="applyDialogVisible" width="30%" :append-to-body="true">-->
<!--      <div class="payRequestContent">-->
<!--        <div style="margin-bottom: 10px;" v-if="isRequest">-->
<!--          <p>提请金额：{{ editObj.price }}{{ editObj.currency }}</p>-->
<!--        </div>-->
<!--        <el-button style="margin-top: 10px;" size="mini" type="primary" v-if="editObj.status == 1"-->
<!--          @click="coutiueApply()">催审</el-button>-->
<!--      </div>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <el-button @click="applyDialogVisible = false">取 消</el-button>-->
<!--      </span>-->
<!--    </el-dialog>-->

      <el-dialog title="审批详情" :visible.sync="applyDialogVisible" width="30%">
          <div class="payRequestContent">
              <div style="margin-bottom: 10px;">
                  <p>提请金额：{{ editObj.price }}{{ editObj.currency }}</p>
              </div>
              <div style="margin-bottom: 10px" v-for="(item, index) in applyData" :key="index">
                  <p>第{{ index }}层</p>
                  <p>
            <span style="margin-right: 10px" v-for="(item1, index1) in item" :key="index1">
              {{ item1.applyName }}&nbsp;&nbsp;&nbsp;{{ item1.status === 0 ? '待审核' : item1.status == 1 ? '已审核' : '已拒绝'
                }}
              <span v-if="item1.status == 1">{{ dateFormatYMDHMS(item1.createTime, "-") }}</span>
            </span>&nbsp;&nbsp;&nbsp;
                  </p>
              </div>
              <el-button style="    margin-top: 10px;" size="mini" type="primary" v-if="editObj.status == 1"
                         @click="coutiueApply()">催审</el-button>
          </div>
          <span slot="footer" class="dialog-footer">
        <el-button @click="applyDialogVisible = false">取 消</el-button>
      </span>
      </el-dialog>
  </div>
</template>

<script>
import ApplyApi from "@/components/Api/apply.js";
export default {
  data(){
    return{
      applyDialogVisible:false,
      editObj:{},
      applyData:[]
    }
  },
  methods:{
    beforeOpen(obj){
      this.applyDialogVisible = true
      this.editObj = obj
      new ApplyApi('apply').applyDetail(obj.id).then(res => {
        if (res.status === 200) {
          this.applyData = res.data
          this.editObj.step = 1
          for (let obj in res.data) {
            res.data[obj].forEach(element => {
              if (element.status === 1) {
                if (res.data[Number(obj) + 1]) {
                  this.editObj.step = Number(obj) + 1
                }
              }
            });
          }
        } else {
          this.$message.error({ message: res.statusText })
        }
      })
    },
    coutiueApply() {
      if (this.editObj.step) {
        new ApplyApi('apply').firstSendApproval(this.editObj.id, this.editObj.step).then(res => {
          if (res.status == 200) {
            this.$message.success({ message: "催审成功" })
          } else {
            this.$message.error({ message: res.statusText })
          }
        })
      } else {
        this.$message.error({ message: "此状态已无需催审" })
      }
    },
  },
  props:{
    isRequest:{
      type:Boolean,
      default:false,
    }
  }
}
</script>

<style>

</style>